import React, { Component } from 'react';
import MineralUiFlex, { FlexItem as MineralUiFlexItem } from 'mineral-ui/Flex';

// Wrapper for MineralUi grid components
// https://mineral-ui.com/components/flex

export default class Flex extends Component {
  static Item = MineralUiFlexItem;

  render() {
    return <MineralUiFlex {...this.props} />;
  }
}
